var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagraminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1649",
    transform: "translate(-187 -2629)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 16",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(187 2629)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1177"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1176"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 150",
    d: "M212.559 2640.885h-9.115a4.571 4.571 0 00-4.562 4.557v9.115a4.571 4.571 0 004.557 4.557h9.114a4.571 4.571 0 004.557-4.557v-9.115a4.571 4.571 0 00-4.551-4.557zm3.038 13.672a3.041 3.041 0 01-3.038 3.038h-9.115a3.042 3.042 0 01-3.038-3.038v-9.115a3.042 3.042 0 013.038-3.038h9.114a3.041 3.041 0 013.038 3.038v9.115z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1179"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1178"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 19",
    cx: 1.139,
    cy: 1.139,
    r: 1.139,
    fill: "#fff",
    transform: "translate(211.799 2643.923)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1181"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1180"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 151",
    d: "M208 2645.441a4.557 4.557 0 104.557 4.557 4.557 4.557 0 00-4.557-4.557zm0 7.6a3.038 3.038 0 113.038-3.043 3.038 3.038 0 01-3.038 3.043z",
    fill: "#fff"
  }))))));
}
export default SvgInstagraminline;